// extracted by mini-css-extract-plugin
export default {"createTranslation":"CreateTransfer_createTranslation__9Fhgn","wrap":"CreateTransfer_wrap__PLmA-","available":"CreateTransfer_available__2bixl","error":"CreateTransfer_error__wWy6R"};